import isEmpty from 'lodash/isEmpty';
import React, { useLayoutEffect } from 'react';
import { Alert, StyleSheet, View } from 'react-native';
import { AppView, ButtonGroup, CardView, CurrencyAmountText, TextButton, rem, } from 'design-system';
import Button from 'design-system/Button';
import ScrollView from 'design-system/ScrollView';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import Links from 'utils/links';
import { selectDefaultCurrency } from 'reducers/selectors';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import ReferralsList from '../components/ReferralsList';
const EMPTY = {};
const ReferralPayoutScreen = ({ navigation, route, }) => {
    const colors = useColors();
    const activeProgram = useAppSelector((store) => store.referrals.activeProgram || EMPTY);
    const referrals = useAppSelector((store) => store.referrals.referrals || EMPTY);
    const creditReferrals = useAppSelector((store) => store.referrals.creditReferrals || EMPTY);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: route.params?.creditReferrals ? 'Invites' : 'Payouts',
            headerRight: () => (<HelpScreenButton articlesKey={HELP_ARTICLES_KEY.INVITES}/>),
            headerTintColor: colors.elements.primary,
        });
    }, [colors.elements.primary, route.params?.creditReferrals]);
    const claimRewards = () => {
        const { cashableAmount } = referrals;
        if (!cashableAmount) {
            Alert.alert('Hold on 💫', 'There is nothing to collect yet.');
        }
        else {
            navigation.navigateDeprecated('ClaimRewardsDetails', {
                isClaimingReferral: true,
            });
        }
    };
    const { currency, cashableAmount, payedReferralsAmount, pendingVerificationAmount, } = referrals;
    const defaultCurrency = useAppSelector(selectDefaultCurrency);
    if (route.params?.creditReferrals) {
        return (<AppView withFrame={false}>
        <ReferralsList referrals={creditReferrals}/>
      </AppView>);
    }
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <ScrollView secondary>
        <CardView style={styles.headerCard} noMarginTop>
          {typeof cashableAmount === 'number' && (<CurrencyAmountText size="L" value={{
                amount: cashableAmount,
                currency: currency || defaultCurrency,
            }}/>)}
          <Text TextThin-14 Gray>
            Cash available
          </Text>
        </CardView>
        <CardView noMarginTop style={styles.cashRowCard}>
          <View style={styles.cashRow}>
            <Text Text-16>Cash pending</Text>
            <Text Numbers-16>
              {formatAmount(pendingVerificationAmount, currency)}
            </Text>
          </View>
          <View style={styles.cashRow}>
            <Text Text-16>Cash paid</Text>
            <Text Numbers-16>
              {formatAmount(payedReferralsAmount, currency)}
            </Text>
          </View>
        </CardView>
      </ScrollView>
      <ButtonGroup type="floating">
        {!isEmpty(activeProgram) && (<TextButton onPress={Links.openEmmaReferral} style={styles.terms}>
            <Text TextThin-16>T&Cs apply</Text>
          </TextButton>)}
        <Button brand onPress={claimRewards} title="Claim your cash"/>
      </ButtonGroup>
    </AppView>);
};
const styles = StyleSheet.create({
    terms: {
        margin: rem(8),
        alignItems: 'center',
    },
    headerCard: {
        paddingTop: rem(16),
        paddingBottom: rem(19),
        alignItems: 'center',
    },
    cashRowCard: {
        paddingVertical: rem(8),
    },
    cashRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: rem(16),
        flex: 1,
    },
});
export default ReferralPayoutScreen;
